<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:content>
			<main-content :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/QueueRecordCount/store/helpers';
import MainContent from './Content/MainContent.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		MainContent
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	beforeDestroy() {
		this.resetState_();
	}
};
</script>

<style></style>
